<template>
  <div class="modal-backdrop">
    <div class="card col-lg-3 col-md-8 mt-md-4 col-11 p-0 mx-auto" v-if="!displayAPIerrorModal">
      <div class="modal-content border-0">
        <div class="modal-header p-4">          
          <h5 class="modal-title fontsize16 black80 pointer proximanova-bold ml-2 text-center" id="exampleModalLabel" @click="NavigateToBack"> <img src="../assets/Back.svg" v-if="addingNewBadge" class="negmargin5 mr-2 pointer" height="20px" alt="back"/> Your Badges</h5>          
          <button type="button" class="close" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="line"></div>
        <div class="modal-body bodymodal11" v-if="!addingNewBadge">
          <div class="p-3">
            <div class="row pb-3 opacityfont-12" >
                <button class="borderblack60 mb-3 backgroundnone proximanova-semibold black col-12 mt-3 mx-auto p-2 borderradius20 fontsize14" @click="AddNewBadge">Add New Badge</button>
                <div class="col-12 pl-0 pr-0 mt-2" v-for="(savedbadge, index) in userBadgeList" :key="index">
                    <div class="d-flex justify-content-between">
                        <span class="borderblack60 text-capitalize pl-3 pr-3 pointer p-2 my-auto borderradius20 fontsize12 proximanova-semibold col-10 pl-0 pr-0">{{savedbadge.badgeList.badgeIn}}</span>
                        <img src="../assets/white_close_btn.png" height="20px" title="delete" width="20px" alt="close" class="borderradius20 my-auto mr-3 pointer p-1 backgroundcolorgray" @click="deleteSavedBadge(savedbadge, index)">
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="modal-body bodymodal11" v-if="addingNewBadge">
          <div class="p-3">
            <div class="row opacityfont-12" >
              <div>
              <div class="fontsize12 red proximanova mx-auto text-center mt-2" v-if="duplicateBadgeError">Duplicate badges are not allowed.</div>
                <div class="fontsize14 proximanova-semibold black80 mt-3" v-if="createNewBadgeSection">Give your badge a name</div>
                </div>
                <input type="text" class="focusnone col-12 p-2 fontsize14 mt-3 borderradius20 borderblack60 sign-in-navheight" 
                @keyup="getBadgeListBasedOnSearchText" 
                v-model="badgeSearchText"
                maxlength="30"
                placeholder="Search for badges">
                <div class="col-12 d-flex flex-column pl-0 pr-0" v-if="!displayAddNewBadgeSetion">
                  <div v-if="badgeSearchLoader" class="mx-auto">
                    <img src="../assets/loading_gif1.gif" class="instanceloader pt-3 pb-3 mx-auto" alt="loading">
                  </div>  
                  <!-- badge search results -->
                  <div class="pl-0 pr-0 d-flex flex-wrap" v-if="badgeSearchResults.length > 0">
                    <span class="lineheight15 borderblack60 pl-3 pr-3 pointer p-2 mr-2 mt-2 borderradius20 fontsize12 proximanova-semibold"
                      :class="{'backgroundcolor3 white borderblue1' :serbadge.selected}" 
                      v-for="(serbadge, index) in badgeSearchResults" :key="index" 
                      @click="selectFromBadgeSearchResults(serbadge, index)">
                        {{serbadge.badgeIn}}
                      <img src="../assets/white_selected_tick.png" v-if="serbadge.selected" alt="selected" height="15px" width="15px" class="ml-2">
                    </span>
                  </div>
                  <!-- selected badge list for final submission -->
                  <div class="fontsize14 proximanova-bold black80 mt-3" v-if="selectedSuggestedBadges.length>0">Selected Badges</div>
                  <div class="pl-0 pr-0 d-flex flex-wrap" v-if="selectedSuggestedBadges.length > 0">
                    <span class="lineheight15 borderblack60 pl-3 pr-3 pointer p-2 mr-2 mt-2 borderradius20 fontsize12 proximanova-semibold"
                      :class="{'backgroundcolor3 white borderblue1' :selbadge.selected}" 
                      v-for="(selbadge, index) in selectedSuggestedBadges" :key="index"
                      @click="removeSelectedBadge(selbadge, index)">
                        {{selbadge.badgeList.badgeIn}}
                      <img src="../assets/white_close_btn.png" v-if="selbadge.selected" title="remove" alt="remove" height="15px" width="15px" class="ml-2 borderradius20 backgroundcolorred">
                    </span>
                  </div>
                  <!-- suggested badge list -->
                  <div class="fontsize14 proximanova-bold black80 mt-3" v-if="suggestedBadges.length>0">Suggested</div>
                  <div class="pl-0 pr-0 d-flex flex-wrap"  v-if="suggestedBadges.length>0">
                    <span class="lineheight15 borderblack60 pl-3 pr-3 pointer p-2 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold"
                      :class="{'backgroundcolor3 white borderblue1' :sugbadge.selected}" 
                      v-for="(sugbadge, index) in suggestedBadges" :key="index"
                      @click="selectBadgeFromSuggestions(sugbadge, index)">
                        {{sugbadge.badgeList.badgeIn}}
                        <img src="../assets/white_selected_tick.png" v-if="sugbadge.selected" title="selected" alt="selected" height="15px" width="15px" class="ml-2">
                    </span>
                  </div>
                </div>
                <div class="col-12 d-flex flex-column pl-0 pr-0" v-else>
                    <div v-if="createNewBadgeSection">
                        <!-- <div class="fontsize14 proximanova-semibold black80 mt-4 mb-2">Select your badge color</div>
                        <div class="d-flex col-10 pl-0 pr-0 justify-content-between">
                            <div :class="'bg'+color" class="borderradiushalf colorbtn pointer" v-for="(color, index) in colorsList" :key="index"></div>
                        </div> -->
                        <div class="proximanova fontsize12 mt-3"><span class="proximanova-bold">Note : </span>Click on Add button to create new badge</div>
                    </div>
                    <div v-else>
                    <div class="fontsize16 proximanova-semibold black80 mt-4 text-center mx-auto col-10">No badges found that match your search criteria</div>
                    <div class="col-12 pl-0 pr-0 d-flex flex-wrap mt-4">
                        <span class="proximanova fontsize14 black"><span class="proximanova-bold">{{badgeSearchText}}</span> is not here ? 
                            <span class="proximanova-bold pointer" @click="moveToCreateBadgeSection">Create it here</span>
                        </span>
                    </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
            <button class="backgroundcolor3 proximanova-semibold border-0 white col-12 mx-auto p-2 borderradius20 fontsize14 mouseoverbtn2" v-if="!addingNewBadge" @click="close('NOTSUCCESS')">Done</button>
            <button class="backgroundcolor3 proximanova-semibold border-0 white col-12 mx-auto p-2 borderradius20 fontsize14 mouseoverbtn2" :disabled="badgeSearchText.length < 1" v-if="addingNewBadge && createNewBadgeSection" @click="AddNewBadges">Add</button>
            <img src="../assets/uploadvideo.svg" width="30px" class="img-fluid mx-auto ml-1" alt="uploadvideo" v-if="addingNewBadge && !createNewBadgeSection && saveBadgeBtnClicked">
            <button class="backgroundcolor3 proximanova-semibold border-0 white col-12 mx-auto p-2 borderradius20 fontsize14 mouseoverbtn2" :disabled="selectedSuggestedBadges.length<1" v-if="addingNewBadge && !createNewBadgeSection && !saveBadgeBtnClicked" @click="SubmitNewBadges">Save</button>
        </div>
      </div>
    </div>
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12 mx-auto" v-else>
      <div class="modal-content border-0 borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <!-- <span class="proximanova-bold fontsize18 black">Error</span> -->
            <span class="mt-2 proximanova fontsize18 black">Something Went Wrong</span>
            <span class="mt-1 proximanova fontsize16 black60">Sorry, something went wrong there. Try again later.</span>
            <button class="backgroundcolor3 white bordernone proximanova mt-4 p-1 borderradius20 mouseoverbtn2" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default{
   data() {
    return{
      profileId : null,
      displayAPIerrorModal : false,
      selectBadgesList : [],
      suggestedBadges : [
        // {badgeList: {badgeIn : 'Software Engineering'}, selected : false, color : 'Chocolate', bgcolor : 'bgChocolate'},
        // {badgeList: {badgeIn : 'Github Star'}, selected : false, color : 'blue', bgcolor : 'backgroundcolor3'},
        // {badgeList: {badgeIn : 'Creator'}, selected : false, color : 'BlueViolet', bgcolor : 'bgBlueViolet'},
        // {badgeList: {badgeIn : 'Open Source'}, selected : false, color : 'LawnGreen', bgcolor : 'bgLawnGreen'},
        // {badgeList: {badgeIn : 'Blogger'}, selected : false, color : 'HotPink', bgcolor : 'bgHotPink'},
      ],
      selectedSuggestedBadges : [],
      colorsList : ['black', 'gray', 'red', 'yellow', 'green', 'blue'],
      //adding new badge
      duplicateBadgeError : false,
      badgeSearchLoader : false,
      badgeSearchResults : [],
      addingNewBadge : false,
      saveBadgeBtnClicked : false,
      badgeSearchText : '',
      displayAddNewBadgeSetion : false,
      createNewBadgeSection : false,
    }
  },
  props : [
      'userBadgeList'
  ],
  methods:{
    deleteSavedBadge : function(badge, index) {
      console.log("badge : ", index, badge)
      var vm = this;
      httpuserprofile.delete("/userprofile/deleteUserBadge/"+ badge.id)
      .then((response) => {
        console.log("delete user badge list : ", response)
        this.userBadgeList.splice(index, 1)
        vm.$toast.success("Badge deleted successfully")
        console.log("userbadgelist : ", this.userBadgeList)
      }).catch((e) => {
        console.log(e)
      })
    },
    getSuggestedBadgeList : function() {
      httpuserprofile.get("/userprofile/getSuggestedBadgeList")
      .then((response) => {
        // this.badgeSearchResults = response.data;
        // if(this.badgeSearchResults.length < 1) {
        //   this.displayAddNewBadgeSetion = true;
        // }
        console.log("get user badge list suggested: ", response)
        let suggestedList = response.data;
        if(suggestedList && suggestedList.length>0){
          for(var i =0; i < suggestedList.length; i++){
          let obj = {
            badgeList : suggestedList[i],
            selected : false
          }
          this.suggestedBadges.push(obj)
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    AddNewBadge : function() {
        this.addingNewBadge = true;
    },
    NavigateToBack : function() {
      if(this.addingNewBadge){
        this.addingNewBadge = false;
        this.badgeSearchText = '';
        this.displayAddNewBadgeSetion = false;
      }else{
        this.close('NOTSUCCESS')
      }
    },
    close(type) {
        this.$emit('closebadgemodal', type);
    },
    // remove badge from selected badge list
    // update select status for suggested badges
    removeSelectedBadge : function(badge, index){
      this.selectedSuggestedBadges.splice(index, 1)
      if(this.suggestedBadges.length > 0){
        for(var i=0; i< this.suggestedBadges.length; i++){
          if(this.suggestedBadges[i].badgeList.badgeIn == badge.badgeList.badgeIn){
            this.suggestedBadges[i].selected = false;
          }
        }
      }
    },
    // select badge from suggestions list
    selectBadgeFromSuggestions : function(badge, index) {
      //check user saved badges to avoid duplications
      for(var i =0; i < this.userBadgeList.length; i++){
        if(this.userBadgeList[i].badgeList.badgeIn == badge.badgeList.badgeIn){
          this.duplicateBadgeError = true;
          return
        }else{
          this.duplicateBadgeError = false;
        }
      }
        if(badge.selected){
            badge.selected = false;
            if(this.selectedSuggestedBadges.length > 0){
            for(var i =0; i < this.selectedSuggestedBadges.length; i++){
              if(this.selectedSuggestedBadges[i].badgeList.badgeIn == badge.badgeList.badgeIn){
                this.selectedSuggestedBadges.splice(i, 1)
              }
            }
            }
        }else{
            badge.selected = true;
            this.selectedSuggestedBadges.push(badge)
        }
        console.log("selected badges from suggestions : ", this.selectedSuggestedBadges)
    },
    // get badge list based on search text
    getBadgeListBasedOnSearchText : function() {
      this.duplicateBadgeError = false;
      if(this.badgeSearchText.length >=3 && !this.createNewBadgeSection){
        this.badgeSearchLoader = true;
        this.badgeSearchResults = [];
        httpuserprofile.get("/searchController/searchByBadgeIn?badgeIn="+this.badgeSearchText)
        .then((response) => {
          this.badgeSearchLoader = false;
          this.badgeSearchResults = response.data;
          if(this.badgeSearchResults.length < 1) {
            this.displayAddNewBadgeSetion = true;
          }
          console.log("get user badge list searchtext: ", response)
        }).catch((e) => {
          console.log(e)
          this.badgeSearchLoader = false;
        })
      }else{
        this.badgeSearchResults = [];
        this.badgeSearchLoader = false;
      }
    },
    selectFromBadgeSearchResults : function(badge, index) {
      for(var i =0; i < this.userBadgeList.length; i++){
        if(this.userBadgeList[i].badgeList.badgeIn == badge.badgeIn){
          this.duplicateBadgeError = true;
          return
        }else{
          this.duplicateBadgeError = false;
        }
      }
      //check user selected badges to avoid duplications
      for(var j =0; j < this.selectedSuggestedBadges.length; j++){
        if(this.selectedSuggestedBadges[j].badgeList.badgeIn == badge.badgeIn){
          this.duplicateBadgeError = true;
          return
        }else{
          this.duplicateBadgeError = false;
        }
      }
      let obj = {
        badgeList : badge,
        selected : true
      }
      this.selectedSuggestedBadges.push(obj)
      this.badgeSearchResults.splice(index, 1)
    },
    AddNewBadges : function() {
      if(this.badgeSearchText.length > 3){
        let obj = {
          badgeList : {
            badgeIn : this.badgeSearchText
          },
          selected : true
        }
        for(var i =0; i < this.userBadgeList.length; i++){
          if(this.userBadgeList[i].badgeList.badgeIn == obj.badgeList.badgeIn){
            this.duplicateBadgeError = true;
            return
          }else{
            this.duplicateBadgeError = false;
          }
        }
        //check user selected badges to avoid duplications
        for(var j =0; j < this.selectedSuggestedBadges.length; j++){
          if(this.selectedSuggestedBadges[j].badgeList.badgeIn == obj.badgeList.badgeIn){
            this.duplicateBadgeError = true;
            return
          }else{
            this.duplicateBadgeError = false;
          }
        }
        this.selectedSuggestedBadges.push(obj)
        this.displayAddNewBadgeSetion = false;
        this.createNewBadgeSection = false;
        this.badgeSearchText = '';
      }
    },
    SubmitNewBadges : function() {
      console.log("add new badges : ", this.selectedSuggestedBadges)
      var vm = this;
      let obj = this.selectedSuggestedBadges;
      this.saveBadgeBtnClicked = true;
      httpuserprofile.post('/userprofile/insertUserBadge?profileId='+sessionUtils.getUserProfileId(), obj)
      .then(response => {    
        console.log("apply for a job : ", response)
        let savedData = response.data;
        if(savedData && savedData.length > 0){
          for(var i =0; i<savedData.length; i++){
          this.userBadgeList.push(savedData[i])
          }
        }
        vm.$toast.success("Badges saved successfully")
        this.clearSelectedData()
      }).catch(error=>{   
        console.log(error);  
        this.saveBadgeBtnClicked = false;
      }) 
    },
    clearSelectedData : function() {
      this.addingNewBadge = false;
      this.saveBadgeBtnClicked = false;
      this.selectedSuggestedBadges = [];
      if(this.suggestedBadges.length>0){
        for(var i=0 ; i < this.suggestedBadges.length; i++){
          this.suggestedBadges[i].selected = false;
        }
      }
      this.badgeSearchResults = [];
    },
    moveToCreateBadgeSection : function() {
      this.createNewBadgeSection = true;
      this.duplicateBadgeError = false;
    },
    
  },
   mounted() {
    this.profileId=sessionUtils.getUserProfileId();
    this.getSuggestedBadgeList()
    console.log(this.userBadgeList)
  },

}
</script>
<style scoped>
  @import '../css/modal.css';
</style>